/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Col_CodeInputs */

const vi_tea_machines_col_code = /** @type {(inputs: Tea_Machines_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy`)
};

/**

* @param {Tea_Machines_Col_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_col_code = /** @type {((inputs?: Tea_Machines_Col_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Col_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_col_code(inputs)
});